export const pushEvent = (data: object) => {
  try {
    if (!window.dataLayer) {
      window.dataLayer = []
    }

    window.dataLayer.push({ ecommerce: null })
    window.dataLayer.push(window.dmm_mkbase_ga_util.merge_common_data(data))
  } catch (_) {
    // エラーが発生してもアプリケーションをクラッシュさせない
  }
}
